import React, { useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import CodeEditor from "@uiw/react-textarea-code-editor";
const Normal = ({ tracking, print }) => {
    const [state, setState] = useState({
        types: "click_link",
        link_label: "Download Indomaret",
        page_name: "/claim-prized",
        url: "https://us-central1-idm-klik-dev.cloudfunctions.net/klikidm_apps_tracker_gateway",
        params: JSON.stringify({
            // "x-api-key": "fT2vJnJu4dsxTRMphdHE3Z92uwjaBRztGR3ECdRQTEyDDZJGbvGu",
            'Content-Type': 'application/json',
        }, undefined, 4)
    })
    const handleChange = (e) => {
        const { value, name } = e.target
        setState(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const handleSubmit = () => {
        const JSONCONSTANT = {
            types: state.types,
            link_label: state.link_label,
            pageName: state.page_name,
            url: state.url.toString(),
            reqParams: JSON.parse(state.params)
        }
        tracking({ payload: JSONCONSTANT })
        print(`initializeTracking(${JSON.stringify(JSONCONSTANT, null, 2)})`)
    }
    return (
        <>
            <FormGroup>
                <Label>Types</Label>
                <Input onChange={handleChange} name='types' value={state.types} />
            </FormGroup>
            <FormGroup>
                <Label>Link Label</Label>
                <Input onChange={handleChange} name='link_label' value={state.link_label} />
            </FormGroup>
            <FormGroup>
                <Label>Page Name</Label>
                <Input onChange={handleChange} name='page_name' value={state.page_name} />
            </FormGroup>
            <FormGroup>
                <Label>url API</Label>
                <Input onChange={handleChange} name='url' value={state.url} />
            </FormGroup>
            <FormGroup>
                <Label>Request Params API</Label>
                <CodeEditor
                    value={state.params}
                    onChange={handleChange}
                    name='params'
                    minHeight={100}
                    language="JSON"
                    placeholder="Please enter JS code."
                    padding={15}
                    style={{
                        fontFamily:
                            "monospace",
                        fontSize: 12
                    }}
                />
            </FormGroup>
            <div style={{ textAlign: "end" }}>
                <Button type='button' onClick={handleSubmit} color='primary'>Requested Script</Button>
            </div>
        </>)
}

export default Normal